const statesExtended = [
  { label: 'AC', value: 'Acre' },
  { label: 'AL', value: 'Alagoas' },
  { label: 'AP', value: 'Amapá' },
  { label: 'AM', value: 'Amazonas' },
  { label: 'BA', value: 'Bahia' },
  { label: 'CE', value: 'Ceará' },
  { label: 'DF', value: 'Distrito Federal' },
  { label: 'ES', value: 'Espírito Santo' },
  { label: 'GO', value: 'Goías' },
  { label: 'MA', value: 'Maranhão' },
  { label: 'MT', value: 'Mato Grosso' },
  { label: 'MS', value: 'Mato Grosso do Sul' },
  { label: 'MG', value: 'Minas Gerais' },
  { label: 'PA', value: 'Pará' },
  { label: 'PB', value: 'Paraíba' },
  { label: 'PR', value: 'Paraná' },
  { label: 'PE', value: 'Pernambuco' },
  { label: 'PI', value: 'Piauí' },
  { label: 'RJ', value: 'Rio de Janeiro' },
  { label: 'RN', value: 'Rio Grande do Norte' },
  { label: 'RS', value: 'Rio Grande do Sul' },
  { label: 'RO', value: 'Rondônia' },
  { label: 'RR', value: 'Roraíma' },
  { label: 'SC', value: 'Santa Catarina' },
  { label: 'SP', value: 'São Paulo' },
  { label: 'SE', value: 'Sergipe' },
  { label: 'TO', value: 'Tocantins' },
];

const states = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' },
];

export { states, statesExtended };
